<template>
  <!-- <div>
    <b-card
      no-body
      class="py-2 px-1 container-card"
    >
      <b-row class="px-1">
        <b-col
          cols="12"
          class="px-2 mb-1"
        >
          <div>
            <div class="d-flex flex-wrap justify-content-end">
              <div
                class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
              >
                <search />
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="tagsReportTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              >
                <template #cell(seq)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col
          cols="12"
          class="my-1"
        >
          <pagination-with-reorder entity-editable />
        </b-col>
      </b-row>
    </b-card>
  </div> -->
  <coming-soon/>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'

import AddButton from '@/views/components/button/AddButton.vue'
import Search from '@/views/components/search/Search.vue'
import vSelect from 'vue-select'
import EditIcon from '@/@core/components/svg/common/Edit.vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import useTagsReport from './hooks/useTagsReport'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import ComingSoon from '@/views/components/coming-soon/ComingSoon.vue'

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    EditIcon,
    DeleteIcon,
    PaginationWithReorder,
    ComingSoon,
  },
  setup() {
    const { fields, loading, tagsReportTable } = useTagsReport()
    return {
      fields,
      loading,
      tagsReportTable,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
